import React from 'react';
import {Divider, Input, InputAdornment, MenuItem} from '@mui/material';
import {Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import {Option} from '@/components/dropdown-button/DropdownButton';
import FilterMenuItem from './FilterMenuItem';

function FilterMenuTitle({
  label,
  onChangeSearch,
  onChangeOption,
  selectedOptions,
}: {
  label: string;
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeOption: (option: Option) => void;
  selectedOptions: Option[];
}) {
  return (
    <>
      <Input
        placeholder={`${translate('Search')} ${label}`}
        onChange={onChangeSearch}
        disableUnderline
        startAdornment={
          <InputAdornment position="start">
            <Icon
              appearance="primary"
              name="Actions-Search-Generic"
              size="medium"
            />
          </InputAdornment>
        }
        sx={{
          paddingX: '16px',
        }}
      />
      <Divider />
      {selectedOptions?.map((option) => (
        <MenuItem key={option.id} onClick={() => onChangeOption(option)}>
          <FilterMenuItem option={option} isSelected />
        </MenuItem>
      ))}
      {selectedOptions.length > 0 && <Divider />}
    </>
  );
}

export default FilterMenuTitle;
